/**
 * Misma lógica que `supabase/functions/_shared/phoneE164.ts` (marcador / formularios).
 * Perú: 9 dígitos empezando en 9 → +51… ; 11 dígitos 51 + móvil → +51…
 */

export function normalizeDialInputToE164(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';
  const digits = trimmed.replace(/\D/g, '');
  if (!digits) return '';

  if (trimmed.startsWith('+')) {
    return `+${digits}`;
  }

  if (digits.length === 11 && digits.startsWith('51') && digits[2] === '9') {
    return `+${digits}`;
  }
  if (digits.length === 9 && digits.startsWith('9')) {
    return `+51${digits}`;
  }

  if (digits.length >= 8 && digits.length <= 15) {
    return `+${digits}`;
  }
  return digits;
}
